import { useStyles } from '@webapps/styles';
import { Button } from '@material-ui/core';
import { AddRounded, InfoRounded } from '@material-ui/icons';
import { css, cx } from '@emotion/css';
import { SMART_FIELDS } from 'config/constants';
import { useState, useEffect } from 'react';
import { useEditor } from 'context/editor/useEditor';
import { getUsedSmartfields, selectedDocumentFromStore } from 'pages/CFA/Convention/utils/services';
import { getPaginationNumbers } from '../../utils/pagination';
import Pagination from '../Pagination';
import { displayAndPluralize } from '@webapps/utils';
import ReactDOMServer from 'react-dom/server';
import CertifyIcon from 'components/Icons/CertifyIcon';
import AlertMessage from 'pages/CFA/components/AlertMessage';
import { InfoTooltip } from '@webapps/styles';



export default function SmartFieldContainer({ selectedDocument, setSelectedDocument, editorRef, setSelectedConvention, currentPageIndex }) {

  const { classes, global } = useStyles(styles);

  const { state, dispatch } = useEditor();


  const [currentPage, setCurrentPage] = useState(1);
  const [usedSmartfields, setUsedSmartfields] = useState([]);
  const [refreshCounter, setRefreshCounter] = useState(0);


  useEffect(() => {

    const updateSmartfields = async () => {
      try {
        const thisDocumentFormStore = selectedDocumentFromStore(selectedDocument, state);
        const smartfields = await getUsedSmartfields(thisDocumentFormStore);
        setUsedSmartfields(smartfields);
      } catch (error) {
        console.error("Erreur lors de la récupération des smartfields:", error);
      }
    };

    updateSmartfields();
  }, [selectedDocument, refreshCounter, state]);

  useEffect(() => {
    const updateSmartfields = async () => {
      try {
        const thisDocumentFormStore = selectedDocumentFromStore(selectedDocument, state);
        const smartfields = await getUsedSmartfields(thisDocumentFormStore);

        setUsedSmartfields(smartfields);
      } catch (error) {
        console.error("Erreur lors de la récupération des smartfields:", error);
      }
    };

    updateSmartfields();
  }, [selectedDocument, refreshCounter, state]);


  const ITEMS_PER_PAGE = 6;
  const unusedSmartfields = SMART_FIELDS.filter(field => !usedSmartfields.includes(field.value));
  const totalPages = Math.ceil(unusedSmartfields.length / ITEMS_PER_PAGE);
  const paginationNumbers = getPaginationNumbers(currentPage, totalPages, 7);
  const paginatedSmartfields = unusedSmartfields.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleInsertSmartField = async (field) => {
    await field.insertFunction({
      field,
      editorRef,
      setSelectedConvention,
      selectedDocument,
      editorStore: {
        dispatch: dispatch,
        state: state
      },
      currentPageIndex
    });
    setRefreshCounter(prev => prev + 1);

  };

  const handleInsertTable = async (field) => {
    await field.insertFunction({
      TableComponent: field.tableComponent,
      editorRef,
      setSelectedConvention,
      selectedDocument,
      editorStore: { dispatch, state },
      currentPageIndex,
      ReactDOMServer
    });
    setRefreshCounter(prev => prev + 1);
  };

  return (
    <div className={classes["framerDiv"]}>
      <div className={classes["framerDiv2"]}>
        <div className={classes["framerDiv3"]}>
          <div className={global.title}>Champs dynamiques</div>
          <InfoTooltip
          position="bottom"
          forceVisible={false}
          title="Comment ça marche ?"
          description="Retrouvez ici un résumé de votre comptabilité sur l'année, incluant les factures transmises, à venir, et leur statut de règlement."
          link={{ text: "En savoir plus" }}
        />
        </div>
        <div className={global.subTitle}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</div>
      </div>
      {unusedSmartfields.length > 0 ? <>
        <AlertMessage>
          <div className={global.alertErrorText}>Les champs obligatoire ne sont pas tous présent <strong>{`(${displayAndPluralize(unusedSmartfields.length, 'champ', 'champs')})`}</strong></div>
        </AlertMessage>
        <div className={cx(classes["framerDiv5"], css({
          ".MuiButton-label": {
            gap: "6px",
          }
        }))}>
          {
            paginatedSmartfields.map((field) => (
              <Button
                className={classes["framerButton"]}
                onClick={() => field.type === "table" ? handleInsertTable(field) : handleInsertSmartField(field)}
                key={field.value}
              >
                <AddRounded className={classes["addIcon"]} />
                <div className={classes["framerP4"]}>{field.label}</div>
              </Button>
            ))
          }
        </div>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          paginationNumbers={paginationNumbers}
        />
      </> :
        <div className={classes.flexRow}>
          <CertifyIcon className={classes["certifyIcon"]} />
          <div className={classes["framerP6"]}>Vous avez ajoutés tous les champs disponibles</div>
        </div>
      }
    </div>
  );
}

const styles = ({ spacing, breakpoints }) => ({
  "framerDiv": {
    alignItems: "flex-start",
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    display: "flex",
    flexDirection: "column",
    height: "min-content",
    justifyContent: "flex-start",
    paddingBottom: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "20px",
    width: "100%",
    gap: "20px",

    [breakpoints.down(1255)]: {
      width: "100%",
    },
  },
  "framerDiv2": {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    height: "min-content",
    justifyContent: "flex-start",
    width: "100%",
    gap: "10px",
    overflow: "visible",
  },
  "framerDiv3": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    justifyContent: "flex-start",
    width: "100%",
    gap: "6px",
    overflow: "visible",
  },
  "infoIcon": {
    height: "16px",
    width: "16px",
    fill: "#a8caff",
  },
  "infoIconError": {
    height: "16px",
    width: "16px",
    fill: "#f50057",
  },
  "certifyIcon": {
    height: "20px",
    width: "20px",
    fill: "#a8caff",
  },
  "framerDiv4": {
    borderBottomWidth: "1px",
    borderColor: "#f50057",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderStyle: "dashed",
    borderTopWidth: "1px",
    alignItems: "center",
    backgroundColor: "#fbd3d5",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    justifyContent: "flex-start",
    paddingBottom: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "10px",
    width: "100%",
    gap: "5px",
    overflow: "visible",
  },
  "framerP3": {
    fontFamily: "\"Roboto\", sans-serif",
    fontSize: "14px",
    textAlignment: "left",
    color: "#f50057",
  },
  "framerDiv5": {
    display: "grid",
    gridAutoRows: "minmax(0px, 1fr)",
    gridTemplateColumns: "repeat(3, minmax(50px, 1fr))",
    gridTemplateRows: "repeat(2, minmax(0px, 1fr))",
    height: "min-content",
    justifyContent: "center",
    width: "100%",
    gap: "6px",
    overflow: "visible",

    [breakpoints.down(1255)]: {
      gridTemplateColumns: "repeat(3, minmax(50px, 1fr))",
      gridTemplateRows: "repeat(2, minmax(0px, 1fr))",
    },
  },
  "framerButton": {
    transition: "none",
    alignItems: "center",
    backgroundColor: "#f3f7ff",
    borderRadius: "5px",
    border: "1px dashed #C0D9FF",
    display: "flex",
    flexDirection: "row",
    height: "100%",
    justifyContent: "flex-start",
    paddingBottom: "6px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "6px",
    gap: "6px",
    width: "100%",
    fontWeight: "400",

    "&:hover": {

      "& div": {
        color: "#0060f9 !important",
      },
      backgroundColor: "#c0d9ff",
      height: "min-content",
    },

  },
  "addIcon": {
    height: "20px",
    width: "20px",
    fill: "#0060f9",
  },
  "framerP4": {
    fontFamily: "\"Roboto\", sans-serif",
    fontSize: "13.5px",
    lineHeight: "13.5px",
    color: "#152652",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  "framerP6": {
    fontFamily: "\"Roboto\", sans-serif",
    fontSize: "12px",
    lineHeight: "12px",
    textAlignment: "center",
    color: "#5d75a8",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "6px",
  },
});